<div nz-row nzJustify="center">
  <div nz-col class="qr-code">
    <img nz-image width="200px" height="200px" [nzSrc]="qrCode" [nzFallback]="fallback" alt="enroll qr code"/>
  </div>
</div>
